import { gql } from '@apollo/client';

export const getForms = gql`
  query FormsTriplePlay($subscriptionId: Int!) {
    formsTriplePlay(subscriptionId: $subscriptionId) {
      steps {
        position
        title
        components {
          conditional {
            type
            show
            match
            field
            hide
            value {
              match
              field
              show
              hide
            }
          }
          component
          hidden
          input
          label
          type
          mapping
          name
          position
          props {
            bottomText
            items
            title
            variant
            inputMode
            terms
          }
          propMap
          rowClass
          values
          value
          validation
        }
      }
    }
  }
`;

export default getForms;
